import { render, staticRenderFns } from "./pesoParaLaTallaNinas2a5A.vue?vue&type=template&id=873448b4&scoped=true&"
import script from "./pesoParaLaTallaNinas2a5A.vue?vue&type=script&lang=js&"
export * from "./pesoParaLaTallaNinas2a5A.vue?vue&type=script&lang=js&"
import style0 from "./pesoParaLaTallaNinas2a5A.vue?vue&type=style&index=0&id=873448b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873448b4",
  null
  
)

export default component.exports